// Set to true to bring the "Register" entry back in the navbar Company dropdown
// and the footer Company column. The /register route itself is unaffected.
export const SHOW_REGISTER_NAV = false;

// Matches the hardcoded entry and any CMS nav add-on labelled "Register".
export const isRegisterNavLabel = (label: string) =>
  label.trim().toLowerCase() === 'register';
